export interface Bar { key: string; label: string; value: number; title?: string }

/** Rounds the axis maximum up to a "nice" number (1, 2, 5 × 10ⁿ). */
function niceMax(v: number) {
  if (v <= 4) return 4;
  const p = 10 ** Math.floor(Math.log10(v));
  const m = v / p;
  return (m <= 1 ? 1 : m <= 2 ? 2 : m <= 5 ? 5 : 10) * p;
}

/** Vertical bar chart with a light grid and hover / focus tooltips (no chart library). */
export function BarChart({ bars, label }: { bars: Bar[]; label: string }) {
  const max = niceMax(Math.max(0, ...bars.map((b) => b.value)));
  const ticks = [max, (max * 3) / 4, max / 2, max / 4, 0];
  return (
    <div className="chart">
      <div className="chart-plot" role="img" aria-label={label}>
        <div className="chart-axis" aria-hidden>
          {ticks.map((t) => <span key={t}>{Number.isInteger(t) ? t.toLocaleString("vi-VN") : ""}</span>)}
        </div>
        <div className="chart-area">
          <div className="chart-grid" aria-hidden>{ticks.map((t) => <span key={t} />)}</div>
          {bars.map((b) => (
            <div className="bar" key={b.key} tabIndex={0} aria-label={b.title ?? `${b.label}: ${b.value}`}>
              <div className="bar-fill" style={{ height: `${(b.value / max) * 100}%` }}>
                <span className="bar-tip">{b.title ?? `${b.label}: ${b.value}`}</span>
              </div>
              <span className="bar-label">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
